
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M17.562.91a2.63 2.63 0 012.62 2.63v14.75a2.63 2.63 0 01-2.62 2.62H2.812a2.63 2.63 0 01-2.63-2.62V3.54A2.63 2.63 0 012.812.91h14.75zM7.252 12.54a.49.49 0 00-.4.21l-5.057 7.12c.293.19.642.3 1.017.3h10.35l-5.52-7.43a.49.49 0 00-.3-.191l-.09-.01zm6.04-2.51a.27.27 0 00-.22.12l-2.932 4.73 3.929 5.29h3.493a1.88 1.88 0 001.466-.704l-5.516-9.307a.25.25 0 00-.22-.13zm4.27-8.37H2.812a1.88 1.88 0 00-1.88 1.88v14.75c0 .39.119.752.323 1.053l4.977-7.014a1.23 1.23 0 011-.52c.398-.02.777.17 1 .5l1.427 1.923 2.773-4.473a1 1 0 01.73-.472l.13-.008a1 1 0 01.86.49l5.257 8.87c.021-.11.032-.224.033-.34V3.54a1.88 1.88 0 00-1.88-1.88zM7.242 3.91a2.94 2.94 0 110 5.88 2.94 2.94 0 010-5.88zm0 .75v.01a2.19 2.19 0 102.19 2.18c0-1.21-.98-2.19-2.19-2.19z"}})])
          )
        }
      }
    